<template>
  <v-row class="text-center">
    <v-col>
      <span class="text-h4 white--text">{{ $t('finished.title') }}</span>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "FinishedPage"
}
</script>

<style scoped>

</style>